const LEGAL_URL_PATTERN = /https:\/\/[^\s；，。]+/g;

function splitLegalText(text) {
  const parts = [];
  let cursor = 0;
  for (const match of text.matchAll(LEGAL_URL_PATTERN)) {
    const start = match.index;
    if (start > cursor) parts.push({ text: text.slice(cursor, start) });
    parts.push({ text: match[0], url: match[0] });
    cursor = start + match[0].length;
  }
  if (cursor < text.length) parts.push({ text: text.slice(cursor) });
  return parts;
}

function renderLegalParagraph(React, paragraph, options = {}) {
  const h = React.createElement;
  return h('p', { key: paragraph, className: options.sensitive ? 'legal-sensitive' : undefined }, splitLegalText(paragraph).map((part, index) =>
    part.url
      ? h('a', {
          key: `${part.url}-${index}`,
          href: part.url,
          target: '_blank',
          rel: 'noopener noreferrer',
        }, part.text)
      : h(React.Fragment, { key: `text-${index}` }, part.text)
  ));
}

module.exports = { splitLegalText, renderLegalParagraph };
